import React, { useState, useEffect } from 'react';
import { Col, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
    useNavigate
} from "react-router-dom";

// Redux
import { connect } from 'react-redux';


//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';

// APIs
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalSuspenderAPE = (props) => {
    const navigate  = useNavigate(); 
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [loading, setLoading] = useState(false);
    const [razonSuspension, setRazonSuspension] = useState(undefined);
    
    const updateAPE = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                suspendida: props.data.suspendida ? false : true,
                motivoSuspension: razonSuspension
            },

        }
        try {
            await actualizarAPE(body)
            props.toastSuccess(props.data.suspendida ? 'APE activada!' : 'APE suspendida!')
            navigate('/home/proceso-seleccion');
        }
        catch (error) {
            console.log(error)
            props.toastError('Hubo un error!')
        }
    }
    const handleStateUpdate = async () => {
        await updateAPE()
        props.toggle()
    }


    const renderBody = () => {
        if (props.data.suspendida) {
            return (
                <Col lg='12' md='12' xs="12">
                    <Label>
                        ¿Desea activar la APE?
                    </Label>
                </Col>
            )
        }
        else return (
            <>
                <Col lg='12' md='12' xs="12">
                    <Autocomplete
                        required
                        margin="dense"
                        options={
                            [
                                'TEMAS DE LA COMUNIDAD',
                                'FALTA DE GESTIÓN POR PARTE DE CAMPO',
                                'POR DEFINICIÓN DE UN CAMPO DE CONDICIÓN',
                                'RECURSO NO NECESARIO EN EL MOMENTO',
                                'POR INDICACIÓN DIRECTA DE OPERACIONES',
                                'POR INDICACIÓN DIRECTA DE DIRECCIÓN DE TH',
                                'POR INDICACIÓN DIRECTA DE GERENCIA'
                            ]}
                        key={`key_Sector`}
                        id={`select_Sector`}
                        onChange={(event, newValue) => setRazonSuspension(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label={'Motivo suspensión'} margin="normal" />
                        )}
                        getOptionLabel={(option) => option}
                        renderOption={(option) => (
                            <React.Fragment>
                                {option}
                            </React.Fragment>
                        )}
                    />
                </Col>
            </>
        )
    }

    if (loading) { return <div className={'loading-area'}> <Loading /> </div> }
    else return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Aceptar'}
                onClick={() => { handleStateUpdate() }}
                buttonLoading={false}
                title={`Suspender APE`}
            >
                {renderBody()}
            </CustomModal>
        </React.Fragment>
    );

}

export default connect(mapStateToProps)(ModalSuspenderAPE);